// @ts-nocheck
/**
 * This file is generated by 'file2variable-cli'
 * It is not mean to be edited by hand
 */
import { createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, openBlock as _openBlock, toDisplayString as _toDisplayString } from 'vue';
// tslint:disable
/* eslint-disable */
export function indexTemplateHtml(_ctx, _cache) {
    return (_ctx.step)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "tour-tip",
            style: _ctx.position
        }, [
            _createVNode("span", { class: _ctx.arrowClassName }, null, 2 /* CLASS */),
            _createVNode("div", { class: "tour-content-wrapper" }, [
                _createVNode("p", null, _toDisplayString(_ctx.step.content), 1 /* TEXT */),
                _createVNode("a", {
                    class: "small button tour-next-tip",
                    onClick: _cache[1] || (_cache[1] = function ($event) { return (_ctx.next()); })
                }, _toDisplayString(_ctx.step.next), 1 /* TEXT */),
                _createVNode("a", {
                    class: "tour-close-tip",
                    onClick: _cache[2] || (_cache[2] = function ($event) { return (_ctx.close()); })
                }, "×")
            ])
        ], 4 /* STYLE */))
        : _createCommentVNode("v-if", true);
}
/* eslint-enable */
// tslint:enable
